import { useFormContext } from 'react-hook-form'

import { FormField } from '@/components/ui/form/form-field'
import type { CreateListFormValues } from '@/modules/tiktok-research/videos/ui/create-list-form/validations.ts'

import { FormPickColor } from './FormPickColor.tsx'
import { FormPickIcon } from './FormPickIcon.tsx'

export const CreateListFormFields = () => {
  const form = useFormContext<CreateListFormValues>()

  const color = form.watch('iconColor')

  return (
    <>
      <FormField
        name="name"
        label="List Name"
        placeholder="Enter Name"
      />
      <div className="flex gap-4">
        <FormPickColor
          name="iconColor"
          label="Color"
          placeholder="Pick a color"
        />
        <FormPickIcon
          color={color}
          name="icon"
          label="Icon"
          placeholder="Pick an icon"
        />
      </div>
    </>
  )
}
